import type { Editor } from "@tiptap/core";
import { setSignoffPending } from "./collaborateEditorStorage";

const CHIP_TYPES = new Set(["signoffBadge", "signoff"]);
const ALL_COMMAND_CHIP_TYPES = new Set([
  "signoffBadge",
  "signoff",
  "playbookBadge",
  "playbook",
]);

export function hasSignoffBadge(editor: Editor): boolean {
  let found = false;
  editor.state.doc.descendants((node) => {
    if (node.type.name === "signoffBadge") {
      found = true;
    }
  });
  return found;
}

function collectChipRanges(editor: Editor, types: Set<string>): { from: number; to: number }[] {
  const ranges: { from: number; to: number }[] = [];
  editor.state.doc.descendants((node, pos) => {
    if (types.has(node.type.name)) {
      ranges.push({ from: pos, to: pos + node.nodeSize });
    }
  });
  return ranges;
}

export function deleteChipRanges(editor: Editor, types: Set<string>): void {
  deleteRanges(editor, collectChipRanges(editor, types));
}

function deleteRanges(editor: Editor, ranges: { from: number; to: number }[]): void {
  if (ranges.length === 0) {
    return;
  }
  let tr = editor.state.tr;
  ranges
    .sort((a, b) => b.from - a.from)
    .forEach(({ from, to }) => {
      tr = tr.delete(from, to);
    });
  editor.view.dispatch(tr);
}

export function removeSignoffBadgeNodes(editor: Editor): void {
  deleteChipRanges(editor, new Set(["signoffBadge"]));
}

export function removeSignoffAssigneeNodes(editor: Editor): void {
  deleteChipRanges(editor, new Set(["signoff"]));
}

/** Removes composer badge and assigned sign-off chips. */
export function removeSignoffChips(editor: Editor): void {
  deleteChipRanges(editor, CHIP_TYPES);
}

/** @deprecated Use {@link removeSignoffChips}. */
export const removeSignoffNodes = removeSignoffChips;

export function removeAllCommandChips(editor: Editor): void {
  deleteChipRanges(editor, ALL_COMMAND_CHIP_TYPES);
}

export function insertSignoffBadge(editor: Editor): void {
  removeAllCommandChips(editor);
  editor
    .chain()
    .focus()
    .insertContent([{ type: "signoffBadge" }, { type: "text", text: " " }])
    .run();
  setSignoffPending(editor, true);
}

/** Keep sign-off mode in sync when the badge is deleted (e.g. Backspace). */
export function syncSignoffPendingFromDoc(editor: Editor): void {
  if (!hasSignoffBadge(editor)) {
    setSignoffPending(editor, false);
  }
}
